export default {
  repliquesNFeTableHeaders: [
    {
      text: 'especieDocumento',
      value: 'especieDocumento',
      width: 180,
      filterable: true,
      filterComponent: 'SetFilter',
      isDataTable: true,
      filterParams: {
        filterSet: [
          'DOCUMENTO OFICIAL DE ENTRADA',
          'DOCUMENTO OFICIAL DE SAIDA',
          'DOCUMENTO DE AJUSTE',
          'REMESSA POR CONTA E ORDEM',
        ],
        field: 'especieDocumento',
      },
    },
    {
      text: 'tipo',
      value: 'tipo',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'tipo',
      },
    },
    {
      text: 'filialRepliques',
      value: 'filial',
      width: 180,
      filterable: true,
      filterComponent: 'SetFilter',
      isDataTable: true,
      filterParams: {
        filterSet: [
          'FILIAL SUMARE',
          'FILIAL ITAJAI',
          'FILIAL CABO',
        ],
        field: 'filial',
      },
    },
    {
      text: 'codigoEmpresa',
      value: 'codigoEmpresa',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'codigoEmpresa',
      },
    },
    {
      text: 'descricaoEmpresa',
      value: 'descricaoEmpresa',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'descricaoEmpresa',
      },
    },
    {
      text: 'documento',
      value: 'documento',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'documento',
      },
    },
    {
      text: 'numeroDocumento',
      value: 'numeroDocumento',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'numeroDocumento',
      },
    },
    {
      text: 'dataEmissao',
      value: 'dataEmissao',
      width: 180,
      filterable: true,
      filterComponent: 'DateFilter',
      isDataTable: true,
      filterParams: {
        field: 'dataEmissao',
      },
    },
    {
      text: 'dataMovimento',
      value: 'dataMovimento',
      width: 180,
      filterable: true,
      filterComponent: 'DateFilter',
      isDataTable: true,
      filterParams: {
        field: 'dataMovimento',
      },
    },
    {
      text: 'chaveAcesso',
      value: 'chaveAcesso',
      width: 220,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'chaveAcesso',
      },
    },
    {
      text: 'retornoSefaz',
      value: 'retornoSefaz',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'retornoSefaz',
      },
    },
    {
      text: 'status',
      value: 'status',
      width: 220,
      filterable: true,
      filterComponent: 'SetFilter',
      isDataTable: true,
      filterParams: {
        filterSet: [
          'CANCELADO',
          'ENCERRADO',
          'CONCLUIDO',
          'CONFIRMADO',
          'SOLICITAÇAO CANCELAMENTO',
          'PENDENTE',
          'FINALIZADO',
          'ESTORNADO',
        ],
        field: 'status',
      },
    },
    {
      text: 'codigoBeneficio',
      value: 'codigoBeneficio',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'codigoBeneficio',
      },
    },
    {
      text: 'ICMS',
      value: 'ICMS',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'icms',
      },
    },
    {
      text: 'baseICMS',
      value: 'baseICMS',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'baseICMS',
      },
    },
    {
      text: 'frete',
      value: 'frete',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'frete',
      },
    },
    {
      text: 'totalProdutos',
      value: 'totalProdutos',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'totalProdutos',
      },
    },
    {
      text: 'totalDocumentos',
      value: 'totalDocumentos',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'totalDocumentos',
      },
    },
  ],
  repliquesNFeTableItems: [],
  filtros: {
    termo: '',
    page: 1,
    perPage: 20,
    order: '',
    direcao: '',
    visibilidade: 'todos',
  },
};
